import { memo } from "react";
import Image from "next/image";
import Link from "next/link";

const List = (props) => {
  const { styles, card, editCard, showPaymentModal, isGuest } = props;

  return (
    card && (
      <div className={styles.paymentVia}>
        <div className={styles.paymentViaSelect}>
          <Image
            width="40"
            height="15"
            src={`/assets/cards/${card.brand.toLowerCase()}.png`}
            alt="bag-empty"
            style={{ objectFit: "contain" }}
          />
          <span>Credit card ending in {card.last4}</span>
          {!isGuest && (
            <button
              className={styles.editBtn}
              onClick={() => editCard("edit")}
            ></button>
          )}
        </div>
        <div>
          <ul className={styles.editPayment}>
            {isGuest ? (
              <li>
                {" "}
                <a onClick={() => editCard(card, "add")}>+ Add Payment</a>
              </li>
            ) : (
              <li>
                <a onClick={showPaymentModal}>Change Payment</a>
                <span>|</span>
                <a onClick={() => editCard(card, "add")}>+ Add Payment</a>
              </li>
            )}
          </ul>
        </div>
        <div>
          <p className={styles.myAccountLink}>
            For security reasons, any changes to your card details need to be
            made via{" "}
            <span>
              <Link href="/my-account" target="_blank">
                ‘My Account’
              </Link>
            </span>
            .
          </p>
        </div>
        <div className={styles.stripeMessage}>
          <Image
            width="120"
            height="34"
            src={`/assets/images/powered_by_stripe.png`}
            alt="stripe"
            unoptimized="true"
            style={{ objectFit: "contain" }}
          />
          <span>
            This is a secure 256-bit SSL
            <br />
            encrypted payment.
          </span>
        </div>
      </div>
    )
  );
};

export default memo(List);
